import { Button, DialogActions } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import "../CancelLoan/CancelLoan.scss";
import { fetchAPIData } from "../../../service/service";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Snackbar, Alert } from "@mui/material";

class CancelLoan extends Component {
  constructor() {
    super();
    this.state = {
      isConfirmCancel: false,
      cancelReason: '',
      alertToast: {
        msg: "",
        time: 2000,
        variant: "success",
      },
      open: false,
    };
  }

  handleOpen = () => this.setState({ open: true});
  handleClose = () => this.setState({ open: false});

  onSubmitClk = async () => {
    let reason = this.state.cancelReason;
    let obj = {
      loanStatus: "Cancelled",
      cancellationReason: reason,
      loanId: this.props.loanId,

    };
    const res = await fetchAPIData("cancelLoan", obj);

    if(res){
      this.setState({
        alertToast: {
          msg: "Loan cancelled successfully",
          time: 3000,
          variant: "success",
        },
        cancelReason: ""
      })

      setTimeout(() => {
        this.handleOpen();
      }, 500);
    } else {
      this.setState({
        alertToast: {
          msg: "Something went wrong",
          time: 3000,
          variant: "error",
        },
        cancelReason: ""
      })

      setTimeout(() => {
        this.handleOpen();
      }, 500);
    }
    
    res &&
      this.props.cancel('confirm')
  };

  confirmCancelToogle = event => {
    if(this.state.cancelReason == ''){
      alert("Please write a reason.")
    } else {
    let value = event.target.innerHTML
    if (value?.toLowerCase() === 'yes')
      this.onSubmitClk()
    this.setState(prevState => ({ isConfirmCancel: !prevState.isConfirmCancel }));
  }
  }

  render() {
    const { cancel } = this.props;
    const { isConfirmCancel, cancelReason, alertToast, open } = this.state
    return (
      <>
        <Snackbar
          open={open}
          autoHideDuration={alertToast?.time}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={this.handleClose}
        >
          <Alert
            onClose={this.handleClose}
            severity={alertToast?.variant}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertToast?.msg}
          </Alert>
        </Snackbar>

      <div onClick={this.closecancelLaonmodal}>
        <div className="deleteuserpage">
          <Dialog
            open={this.props.open}
            className="closeCustomerDialogbox"
          >
            <DialogTitle id="customized-dialog-title" className="TitleDiv">
              <div className="deleteconfirmation">
                <div className="Fonts btnSizeFont confrmmessage">
                 By cancelling the loan, you cannot proceed the further loan process for this customer.
                </div>
                <div className="closeButtonDiv"><CloseIcon /* onClick={this.handleCloseModal.bind(this)} */ /></div>
                <TextareaAutosize id="reason"
                  rowsMax={4}
                  style={{ height: "60px" }}
                  aria-label="maximum height"
                  placeholder="Type the reason here for cancelling the loan"
                  className="cancelnumarictextBox"
                  value={cancelReason}
                  onChange={(e) => this.setState({ cancelReason: e.target.value })}
                />
              </div>
            </DialogTitle>
            <DialogContent className="bottomPart">
              <div className="buttonDiv">
                <Button className="cancelbutton Fonts" onClick={() => cancel('cancel')}>
                  Close
                </Button>
                <Button className="savebutton Fonts" onClick={this.confirmCancelToogle}  >
                  Confirm
                </Button>
              </div>
            </DialogContent>
          </Dialog>
          <ConfirmCancel open={isConfirmCancel} closeAction={this.confirmCancelToogle} />
        </div>
      </div>
      </>
    );
  }
}
export default withRouter(CancelLoan);


const ConfirmCancel = props => {
  const { open, closeAction } = props

  return (
    <Dialog open={open} >
      <DialogTitle>Are you sure?</DialogTitle>

      <DialogActions>
        <Button className='confirm' onClick={closeAction}>Yes</Button>
        <Button className='confirm' onClick={closeAction}  >No</Button>
      </DialogActions>
    </Dialog>
  )
}